var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head",class:{'is-fixed': _vm.isFixed, 'no-gap': _vm.noGap},style:({gridTemplateColumns: _vm.layout})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }